import { GetAskRequestAttachmentById } from 'domain/usecases';
import { BaseHttpService } from 'main/factories/http';

export class RemoteGetAskRequestAttachmentById
  extends BaseHttpService<GetAskRequestAttachmentById.Model>
  implements GetAskRequestAttachmentById
{
  async get(): Promise<GetAskRequestAttachmentById.Model> {
    const response = await this.request('get', {
      Accept: 'application/octet-stream',
    });
    return response;
  }
}
